import UAHelper from './uaHelper';

export const redirectToLoginPage = () => {
  const returnUrlParam = encodeURIComponent(window.location.href);
  const loginUrl = UAHelper.isMSite()
    ? `/login?ret=${returnUrlParam}`
    : `app://nativeLogin?ret=${returnUrlParam}`;

  window.location.href = loginUrl;
};
